import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'

const LogoContainer = styled(Link)`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  text-decoration: none;
  color: var(--color-text);
  font-weight: 800;
  font-size: 1.5rem;
  transition: all 0.3s ease;
  position: relative;

  &:hover {
    transform: scale(1.05);
  }
`

const LogoIcon = styled.div`
  width: 45px;
  height: 45px;
  background: var(--gradient-accent);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 15px rgba(37, 99, 235, 0.3);
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: linear-gradient(45deg, transparent, rgba(255, 255, 255, 0.3), transparent);
    transform: rotate(45deg);
    transition: all 0.6s;
  }

  ${LogoContainer}:hover &::before {
    animation: shine 0.6s ease-in-out;
  }

  @keyframes shine {
    0% { transform: translateX(-100%) translateY(-100%) rotate(45deg); }
    100% { transform: translateX(100%) translateY(100%) rotate(45deg); }
  }

  svg {
    width: 26px;
    height: 26px;
    fill: white;
    position: relative;
    z-index: 1;
  }
`

const LogoText = styled.span`
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-weight: 800;
  letter-spacing: -0.02em;
  font-size: 1.625rem;
  
  .fach {
    color: var(--color-text);
    transition: color 0.3s ease;
  }
  
  .fix {
    background: var(--gradient-accent);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    position: relative;
  }

  ${LogoContainer}:hover .fach {
    color: var(--color-primary);
  }
`

interface LogoProps {
  className?: string
  showText?: boolean
}

const Logo: React.FC<LogoProps> = ({ className, showText = true }) => {
  return (
    <LogoContainer to="/" className={className}>
      <LogoIcon>
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 6L9 2L15 6L21 2V8L15 12L9 8L3 12V6Z" />
          <circle cx="18" cy="18" r="3" />
          <path d="M15 15L21 21" strokeWidth="2" strokeLinecap="round" />
        </svg>
      </LogoIcon>
      {showText && (
        <LogoText>
          <span className="fach">Fach</span>
          <span className="fix">FIX</span>
        </LogoText>
      )}
    </LogoContainer>
  )
}

export default Logo 